module.exports = __webpack_public_path__ + "public/images/reviews/ekaterina-smirnova.af2da7c421b9dc24e973c1418638910d.jpg";